import axios from 'axios';

/**
 * The blog has no multilingual REST support (the `lang` query param is ignored),
 * Hungarian posts are told apart by their `/hu/` URL prefix. A batch is fetched and
 * filtered here, because the two languages are mixed in the list.
 */
const FETCH_BATCH_SIZE = 30;

function isHungarianPost(post) {
  try {
    return new URL(post.link).pathname.startsWith('/hu/');
  }
  catch {
    return false;
  }
}

export default {
  getLatests(language, limit = 5) {
    const instance = axios.create({
      baseURL: process.env.VUE_APP_WORDPRESS_URL,
      withCredentials: false,
      headers: {
        'Accept': '*/*',
        'Content-Type': 'application/json',
      },
    });

    const wantsHungarian = language === 'hu';

    return instance.get('/wp-json/wp/v2/posts?per_page=' + FETCH_BATCH_SIZE + '&_fields[]=id&_fields[]=link&_fields[]=date_gmt&_fields[]=title&_fields[]=yoast_head_json.og_image')
      .then(resp => resp.data
        .filter(post => isHungarianPost(post) === wantsHungarian)
        .slice(0, limit));
  },
};
